import { IconType } from "@/components/atoms/Icon/Icon.types";
import styles from "./Icon.module.css";

interface IconProps {
  type: IconType;
  className?: string;
  title?: string;
}

export function Icon({ type, className, title }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={[styles.icon, className].join(" ")}
    >
      {title && <title>{title}</title>}
      <use xlinkHref={`#icon__${type}`} />
    </svg>
  );
}
